export type { LibrarySketch, ExtractedParam, SketchCategory, RuntimeMode } from './types';
import { SKETCH_CATEGORIES } from './categories';
export { SKETCH_CATEGORIES };
export type { SketchCategoryId } from './categories';
export { loadSketchThumbnail } from './thumbnails';

import { effectSketches } from './effects';
import { postEffectSketches } from './post-effects';
import { generatorSketches } from './generators';
import { particleSketches } from './particles';
import { audioReactiveSketches } from './audio-reactive';
import { threeDSketches } from './three-d';
import { interactiveSketches } from './interactive';
import { typographySketches } from './typography';
import { utilitySketches } from './utilities';

import { SHADER_INPUT_TYPES } from '../media/contract';

import type { LibrarySketch } from './types';

/**
 * All curated library sketches shipped with the platform.
 * Organized by category for the Library tab browser.
 */
export const LIBRARY_SKETCHES: LibrarySketch[] = [
  ...postEffectSketches,
  ...effectSketches,
  ...generatorSketches,
  ...particleSketches,
  ...audioReactiveSketches,
  ...threeDSketches,
  ...interactiveSketches,
  ...typographySketches,
  ...utilitySketches,
];

/**
 * Input types the app can deliver to a running sketch: every media type in the
 * shader contract. A sketch declaring anything else stays out of the browsers
 * instead of rendering flat.
 */
export const SUPPORTED_SKETCH_INPUTS: ReadonlySet<string> = new Set<string>(SHADER_INPUT_TYPES);

export function isSketchAvailable(sketch: LibrarySketch): boolean {
  return sketch.inputTypes.every((type) => SUPPORTED_SKETCH_INPUTS.has(type));
}

/** Sketches shown in the library browsers. */
export const AVAILABLE_SKETCHES: LibrarySketch[] = LIBRARY_SKETCHES.filter(isSketchAvailable);

/** Categories that have at least one available sketch, in display order. */
export const AVAILABLE_SKETCH_CATEGORIES = SKETCH_CATEGORIES.filter((category) =>
  AVAILABLE_SKETCHES.some((sketch) => sketch.category === category.id),
);

/** Look up a single sketch by its unique ID */
export function getSketchById(id: string): LibrarySketch | undefined {
  return LIBRARY_SKETCHES.find((s) => s.id === id);
}
